import {
  ApplicationRef,
  createComponent,
  ENVIRONMENT_INITIALIZER,
  EnvironmentInjector,
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
} from '@angular/core';
import { TxToastContainerComponent } from '@targx/components/tx-toast/tx-toast-container.component';

/**
 * Mounts the global TxToastContainer into document.body via
 * ENVIRONMENT_INITIALIZER — works with all Fuse layouts without
 * touching any template.
 */
export function provideToast(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: ENVIRONMENT_INITIALIZER,
      multi: true,
      useValue: () => {
        const appRef = inject(ApplicationRef);
        const envInjector = inject(EnvironmentInjector);

        const containerRef = createComponent(TxToastContainerComponent, {
          environmentInjector: envInjector,
        });

        appRef.attachView(containerRef.hostView);
        document.body.appendChild(containerRef.location.nativeElement);
      },
    },
  ]);
}
